<div class="dp-pill" [class.dp-pill--disabled]="disabled" (click)="toggle()">
    <span [class.dp-placeholder]="!value">{{label}}</span>
    <a *ngIf="value && !disabled" class="dp-clear" (click)="clear($event)" title="Quitar fecha">&times;</a>
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" [class.dp-chevron--open]="open"><path d="M6 9l6 6 6-6" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
</div>
<div class="dp-panel" *ngIf="open" (click)="$event.stopPropagation()">
    <div class="dp-cal-header">
        <button type="button" class="dp-nav" (click)="prevMonth()">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M15 6l-6 6 6 6" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <div class="dp-month-year-select">
            <select [ngModel]="viewMonth" (ngModelChange)="onMonthSelect($event)" (click)="$event.stopPropagation()">
                <option *ngFor="let m of monthOptions" [ngValue]="m.value">{{m.label}}</option>
            </select>
            <select [ngModel]="viewYear" (ngModelChange)="onYearSelect($event)" (click)="$event.stopPropagation()">
                <option *ngFor="let y of yearOptions" [ngValue]="y">{{y}}</option>
            </select>
        </div>
        <button type="button" class="dp-nav" (click)="nextMonth()">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M9 6l6 6-6 6" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
    </div>
    <div class="dp-weekdays">
        <span *ngFor="let w of weekdayLabels">{{w}}</span>
    </div>
    <div class="dp-days">
        <button type="button" *ngFor="let d of calendarDays; trackBy: trackByIso"
            class="dp-day"
            [class.dp-day--muted]="!d.inMonth"
            [class.dp-day--today]="d.isToday"
            [class.dp-day--selected]="d.iso === value"
            (click)="selectDay(d.iso)">
            {{d.day}}
        </button>
    </div>
</div>
